module.exports = __webpack_public_path__ + "img/avt.73dfcf25.png";